import { Page, Topbar } from 'components'
import React from 'react'
import { useParams } from 'react-router'
import { RoutingParams } from 'routes'
import { DetailsUsers } from 'views/users/detailsUsers'
import { ListUsers } from 'views/users/listUsers'
import { MainSidebar } from '../views'

export interface IUsersProps { };

/**
 * Shows a list of all users a manager is taking care of.
 *
 * @type Manager
 */
export const Users = (props: IUsersProps) => {
  const params: RoutingParams = useParams<RoutingParams>();
  
  return (
    <Page sidebar={<MainSidebar />} topbar={<Topbar />}>
      {params.id ? <DetailsUsers /> : <ListUsers />}
    </Page>
  );
};
